module.exports = __webpack_public_path__ + "assets/img/client-logo-gtcap-mono.18786540.png";